<template>
  <CourseBlock
    title-margin="small"
    class="certificate"
  >
    <template #title>
      Сертификат от&nbsp;{{ data.vendor }}
    </template>

    <template #content>
      <p class="certificate__description p p--2" v-html="data.description" />

      <div class="certificate__picture-wrapper">
        <UiPicture
          :data="data.images"
          width="240"
          height="170"
          mobile-stretch
          class="certificate__picture ui-shadow-15pt"
        />

        <UiButton
          theme="neogene"
          size="small"
          size-mode="medium-lg"
          class="certificate__button"
          @click="handleClickButton"
        >
          Пример сертификата
        </UiButton>
      </div>

      <UiDetailsModal
        v-if="isShowModal"
        @click:close="isShowModal = false"
      >
        <UiPicture
          :data="data.images"
          :is-cover="false"
          width="280"
          height="196"
          class="certificate__details"
        />
      </UiDetailsModal>
    </template>
  </CourseBlock>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import type { Images } from '@academica-box/components/Media/UiPicture/types'
  import UiPicture from '@academica-box/components/Media/UiPicture/UiPicture.vue'
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import UiDetailsModal from '@academica-box/components/Modals/UiDetailsModal/UiDetailsModal.vue'
  import CourseBlock from '@/components/CourseBlock.vue'

  defineProps<{
    data: {
      vendor: string;
      description: string;
      images: Images;
    };
  }>()

  const emits = defineEmits(['click:button'])

  const isShowModal = ref(false)

  const handleClickButton = () => {
    isShowModal.value = true

    emits('click:button')
  }
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;

  .certificate__description {
    margin-bottom: 24px;
    color: var(--text-secondary-color);

    @include media(lg) {
      margin-bottom: 40px;
    }
  }

  .certificate__picture-wrapper {
    padding: 32px 20px 20px;
    border-radius: 16px;
    background-color: var(--bg-secondary-color);

    @include media(md) {
      display: grid;
    }

    @include media(lg) {
      padding: 56px 24px 24px;
    }
  }

  .certificate__picture {
    margin-bottom: 24px;

    @include media(sm-max) {
      padding-bottom: calc(100% / 4 * 2.80);
    }

    @include media(md) {
      justify-self: center;
      width: 334px;
      height: 236px;
    }

    @include media(lg) {
      width: 390px;
      height: 274px;
      margin-bottom: 22px;
    }
  }

  .certificate__button {
    position: relative;
    justify-self: flex-end;
  }
</style>
